import { PendingWork } from '../../services/admin';

interface PendingWorkCardProps {
  data: PendingWork | null;
}

export function PendingWorkCard({ data }: PendingWorkCardProps) {
  if (!data) {
    return (
      <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-6">
        <h2 className="text-lg font-semibold text-slate-900 dark:text-white mb-4">Kolejka przetwarzania</h2>
        <div className="animate-pulse space-y-3">
          <div className="h-4 bg-slate-200 dark:bg-slate-700 rounded w-3/4" />
          <div className="h-4 bg-slate-200 dark:bg-slate-700 rounded w-1/2" />
        </div>
      </div>
    );
  }

  const items = [
    { label: 'Orzeczenia bez embeddingów', value: data.judgmentsWithoutEmbeddings },
    { label: 'Fragmenty bez embeddingów', value: data.chunksWithoutEmbeddings },
    { label: 'Do reprocessingu', value: data.judgmentsNeedingReprocessing },
    { label: 'Pliki SAOS do importu', value: data.filesAwaitingIngestion },
    { label: 'Pliki CBOSA do importu', value: data.cbosaFilesAwaitingIngestion },
  ];

  const totalPending = items.reduce((sum, item) => sum + item.value, 0);

  return (
    <div className="bg-white dark:bg-slate-800 rounded-xl border border-slate-200 dark:border-slate-700 p-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="text-lg font-semibold text-slate-900 dark:text-white">Kolejka przetwarzania</h2>
        {totalPending > 0 && (
          <span className="text-sm font-medium text-amber-600 dark:text-amber-400">
            {totalPending.toLocaleString()} do przetworzenia
          </span>
        )}
      </div>

      <div className="space-y-3">
        {items.map((item) => (
          <div key={item.label} className="flex justify-between items-center">
            <span className="text-sm text-slate-600 dark:text-slate-400">{item.label}</span>
            <span
              className={`font-medium ${
                item.value > 0
                  ? 'text-amber-600 dark:text-amber-400'
                  : 'text-green-600 dark:text-green-400'
              }`}
            >
              {item.value.toLocaleString()}
            </span>
          </div>
        ))}
      </div>

      {totalPending === 0 && (
        <div className="mt-4 p-3 bg-green-50 dark:bg-green-900/20 rounded-lg">
          <p className="text-sm text-green-700 dark:text-green-300 text-center">
            Wszystko przetworzone
          </p>
        </div>
      )}
    </div>
  );
}
